import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export function formatDate(date: string | Date, formatting: string): string {
  try {
    return dayjs(date).format(formatting);
  } catch (e) {
    return '';
  }
}

export function formatChallengeDateWithTimezone(
  date: string | Date,
  timezone: string,
  format: string
): string {
  if (date && timezone) {
    return dayjs(dayjs(date, { utc: true }).tz(timezone, true).format()).format(
      format
    );
  }
  return '';
}

export function formatDateWithTimezone(
  date: string | Date,
  timezone: string,
  format: string
): string {
  if (timezone) {
    return dayjs(date).tz(timezone).format(format);
  }
  return dayjs(date).format(format);
}

export function calculateDaysBetweenDates(
  startDate: string,
  endDate: string
): number {
  return parseFloat(
    dayjs
      .duration(dayjs(endDate).diff(dayjs(startDate)))
      .asDays()
      .toFixed(0)
  );
}

export function timezoneStringToGmtOffsetString(timezone: string) {
  const date = dayjs().tz(timezone);
  const offset = date.utcOffset() / 60;
  return `GMT${offset >= 0 ? '+' : ''}${offset}:00`;
}
